"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

const ActionMenuItem = props => {
  const {
    value,
    name,
    onClick
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "action-menu-item",
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('action-menu-item__icon', "action-menu-item__icon--".concat(value))
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "action-menu-item__name"
  }, name));
};

ActionMenuItem.propTypes = {
  value: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired,
  onClick: _propTypes.default.func.isRequired
};
var _default = ActionMenuItem;
exports.default = _default;